<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Distribuidor</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Distribuidor</h6>
    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdCompania}}</mat-label>
                        <mat-select [compareWith]="compareCompanias" formControlName="idCompania">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let c of companias" [value]="c.id">{{c.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idCompania').hasError('required')) && form.get('idCompania').touched ">
                            {{Validaciones.Compania}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field class="readonly-form-field" color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdSalesOrg}}</mat-label>
                        <mat-select [compareWith]="compareSalesOrgs" formControlName="idSalesOrg">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let s of salesOrgs" [value]="s.id">{{s.descripcion}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idSalesOrg').hasError('required')) && form.get('idSalesOrg').touched ">
                            {{Validaciones.SalesOrg}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdDivision}}</mat-label>
                        <mat-select (selectionChange)="selectDivisiones($event.value)" [compareWith]="compareDivisiones" formControlName="idDivision">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let d of divisiones" [value]="d.id">{{d.displayValue}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(form.get('idDivision').hasError('required')) && form.get('idDivision').touched ">
                            {{Validaciones.IdDivision}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdRegion}}</mat-label>
                        <mat-select (selectionChange)="selectRegiones($event.value)" [compareWith]="compareRegiones" formControlName="idRegion">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let r of regiones" [value]="r.id">{{r.displayValue}}
                            </mat-option>
                        </mat-select>

                        <mat-error
                            *ngIf="(form.get('idRegion').hasError('required')) && form.get('idRegion').touched ">
                            {{Validaciones.IdRegion}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.IdZonaVendedor}}</mat-label>
                        <mat-select (selectionChange)="selectZonasVendedores($event.value)" [compareWith]="compareZonasVendedores" formControlName="idZonaVendedor">
                            <mat-option [value]="-1">- Seleccione -</mat-option>
                            <mat-option *ngFor="let vZ of zonasVendedores" [value]="vZ.id">{{vZ.displayValue}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="!zonasVendedores.length">(Seleccioná una División)</mat-hint>
                        <mat-error
                            *ngIf="(form.get('idZonaVendedor').hasError('required')) && form.get('idZonaVendedor').touched ">
                            {{Validaciones.IdZonaVendedor}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.Codigo}}</mat-label>
                        <input type="text" matInput formControlName="id">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('id')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('id').hasError('required')) && form.get('id').touched ">
                            {{Validaciones.Codigo}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.Descripcion}}</mat-label>
                        <input type="text" matInput formControlName="descripcion">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('descripcion')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <mat-error
                            *ngIf="(form.get('descripcion').hasError('required') || form.get('descripcion').hasError('maxLength')) && form.get('descripcion').touched ">
                            {{Validaciones.Descripcion}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.IdSalesOffice}}</mat-label>
                        <input type="text" matInput formControlName="idSalesOffice">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('idSalesOffice')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <mat-error
                            *ngIf="(form.get('idSalesOffice').hasError('required')) && form.get('idSalesOffice').touched ">
                            {{Validaciones.IdSalesOffice}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.UsuarioRed}}</mat-label>
                        <input type="text" matInput formControlName="usuarioRed">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('usuarioRed')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('usuarioRed').hasError('required')) && form.get('usuarioRed').touched ">
                            {{Validaciones.UsuarioRed}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.NroCliente}}</mat-label>
                        <input type="text" matInput formControlName="nroCliente">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('nroCliente')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('nroCliente').hasError('required')) && form.get('nroCliente').touched ">
                            {{Validaciones.NroCliente}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.NroCasaMatriz}}</mat-label>
                        <input type="text" matInput formControlName="nroCasaMatriz">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('nroCasaMatriz')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('nroCasaMatriz').hasError('required')) && form.get('nroCasaMatriz').touched ">
                            {{Validaciones.NroCasaMatriz}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.DireccionEnvio}}</mat-label>
                        <input type="text" matInput formControlName="direccionEnvio">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('direccionEnvio')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('direccionEnvio').hasError('required')) && form.get('direccionEnvio').touched ">
                            {{Validaciones.DireccionEnvio}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.EmailDistribuidor}}</mat-label>
                        <input type="text" matInput formControlName="emailDistribuidor">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('emailDistribuidor')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('emailDistribuidor').hasError('required')) && form.get('emailDistribuidor').touched ">
                            {{ Validaciones.EmailDistribuidor }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.DiasAlCierre}}</mat-label>
                        <input type="number" matInput formControlName="diasAlCierre">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button>
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>

                        <mat-error
                            *ngIf="(form.get('diasAlCierre').hasError('required')) && form.get('diasAlCierre').touched ">
                            {{ Validaciones.DiasAlCierre     }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="habilitacion" color="primary-darker">
                        {{Etiquetas.Habilitacion}}
                    </mat-checkbox>

                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">

                    <mat-checkbox class="cell" formControlName="directo" color="primary-darker">
                        {{Etiquetas.Directo}}
                    </mat-checkbox>

                </div>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" (click)="guardarDistribuidor()"  mat-flat-button
        color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>

</mat-dialog-actions>


